var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIr(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: 512,
    width: 512,
    id: "flag-icon-css-ir",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fillOpacity: 0.67,
    d: "M185.98 0h496.06v496.06H185.98z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)",
    fillRule: "evenodd",
    transform: "translate(-191.96) scale(1.0321)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h868.11v496.06H0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#da0000",
    d: "M0 333.13h868.11v162.93H0z"
  }), /*#__PURE__*/React.createElement("g", {
    strokeWidth: "1pt",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M165.025 340.035h47.543v3.271h-47.543zm7.089 16.358h3.271v3.177h-3.271zm40.577-.103v3.271h-9.5v-3.271zm5.111-16.255h3.272v19.532h-3.272z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.728 356.29v3.271h-18.006v-3.271zm-33.538-7.642h3.272v10.92h-3.272z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.05 340.035h3.272v19.532h-3.272zm-8.18 0h3.273v19.532h-3.272zm-43.404 7.774v3.271h-17.352v-3.271zm38.076 0v3.271H203.19v-3.271z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.19 348.648h3.272v10.92h-3.272z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.19 348.648h3.272v10.92h-3.272z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.19 348.648h3.272v10.92h-3.272zm-38.076 0h3.271v10.92h-3.271zm27.909 0h3.272v10.92h-3.272zm-13.827 0h3.272v10.92h-3.272z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.319 356.29v3.271H180.65v-3.271zm.976-8.481v3.271h-9.3v-3.271z"
  })), /*#__PURE__*/React.createElement("g", {
    strokeWidth: "1pt",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M86.94 340.035h47.543v3.271H86.94zm7.089 16.358H97.3v3.177h-3.27zm40.577-.103v3.271h-9.5v-3.271zm5.111-16.255h3.272v19.532h-3.272z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.643 356.29v3.271h-18.006v-3.271zm-33.538-7.642h3.272v10.92h-3.272z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.965 340.035h3.272v19.532h-3.272zm-8.179 0h3.272v19.532h-3.272zm-43.405 7.774v3.271H87.03v-3.271zm38.076 0v3.271h-17.352v-3.271z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.105 348.648h3.272v10.92h-3.272z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.105 348.648h3.272v10.92h-3.272z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.105 348.648h3.272v10.92h-3.272zm-38.076 0H90.3v10.92h-3.27zm27.909 0h3.272v10.92h-3.272zm-13.828 0h3.273v10.92h-3.272z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.234 356.29v3.271h-14.668v-3.271zm.976-8.481v3.271h-9.3v-3.271z"
  })), /*#__PURE__*/React.createElement("g", {
    strokeWidth: "1pt",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M242.465 340.035h47.543v3.271h-47.543zm7.089 16.358h3.271v3.177h-3.271zm40.577-.103v3.271h-9.5v-3.271zm5.111-16.255h3.272v19.532h-3.272z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314.168 356.29v3.271h-18.006v-3.271zm-33.538-7.642h3.272v10.92h-3.272z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M311.49 340.035h3.272v19.532h-3.272zm-8.18 0h3.273v19.532h-3.272zm-43.404 7.774v3.271h-17.352v-3.271zm38.076 0v3.271H280.63v-3.271z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.63 348.648h3.272v10.92h-3.272z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.63 348.648h3.272v10.92h-3.272z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.63 348.648h3.272v10.92h-3.272zm-38.076 0h3.271v10.92h-3.271zm27.909 0h3.272v10.92h-3.272zm-13.827 0h3.272v10.92h-3.272z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272.759 356.29v3.271H258.09v-3.271zm.976-8.481v3.271h-9.3v-3.271z"
  })), /*#__PURE__*/React.createElement("g", {
    strokeWidth: "1pt",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M789.275 340.035h47.543v3.271h-47.543zm7.089 16.358h3.271v3.177h-3.271zm40.577-.103v3.271h-9.5v-3.271zm5.111-16.255h3.272v19.532h-3.272z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M860.978 356.29v3.271h-18.006v-3.271zm-33.538-7.642h3.272v10.92h-3.272z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M858.3 340.035h3.272v19.532H858.3zm-8.18 0h3.273v19.532h-3.272zm-43.404 7.774v3.271h-17.352v-3.271zm38.076 0v3.271H827.44v-3.271z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M827.44 348.648h3.272v10.92h-3.272z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M827.44 348.648h3.272v10.92h-3.272z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M827.44 348.648h3.272v10.92h-3.272zm-38.076 0h3.271v10.92h-3.271zm27.909 0h3.272v10.92h-3.272zm-13.827 0h3.272v10.92h-3.272z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M819.569 356.29v3.271H804.9v-3.271zm.976-8.481v3.271h-9.3v-3.271z"
  })), /*#__PURE__*/React.createElement("g", {
    strokeWidth: "1pt",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M320.405 340.035h47.543v3.271h-47.543zm7.089 16.358h3.271v3.177h-3.271zm40.577-.103v3.271h-9.5v-3.271zm5.111-16.255h3.272v19.532h-3.272z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M392.108 356.29v3.271h-18.006v-3.271zm-33.538-7.642h3.272v10.92h-3.272z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M389.43 340.035h3.272v19.532h-3.272zm-8.18 0h3.273v19.532h-3.272zm-43.404 7.774v3.271h-17.352v-3.271zm38.076 0v3.271H358.57v-3.271z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M358.57 348.648h3.272v10.92h-3.272z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M358.57 348.648h3.272v10.92h-3.272z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M358.57 348.648h3.272v10.92h-3.272zm-38.076 0h3.271v10.92h-3.271zm27.909 0h3.272v10.92h-3.272zm-13.827 0h3.272v10.92h-3.272z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M350.699 356.29v3.271H336.03v-3.271zm.976-8.481v3.271h-9.3v-3.271z"
  })), /*#__PURE__*/React.createElement("g", {
    strokeWidth: "1pt",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M398.625 340.035h47.543v3.271h-47.543zm7.089 16.358h3.271v3.177h-3.271zm40.577-.103v3.271h-9.5v-3.271zm5.111-16.255h3.272v19.532h-3.272z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M470.328 356.29v3.271h-18.006v-3.271zm-33.538-7.642h3.272v10.92h-3.272z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M467.65 340.035h3.272v19.532h-3.272zm-8.18 0h3.273v19.532h-3.272zm-43.404 7.774v3.271h-17.352v-3.271zm38.076 0v3.271H436.79v-3.271z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M436.79 348.648h3.272v10.92h-3.272z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M436.79 348.648h3.272v10.92h-3.272z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M436.79 348.648h3.272v10.92h-3.272zm-38.076 0h3.271v10.92h-3.271zm27.909 0h3.272v10.92h-3.272zm-13.827 0h3.272v10.92h-3.272z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M428.919 356.29v3.271H414.25v-3.271zm.976-8.481v3.271h-9.3v-3.271z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#239f40",
    d: "M0 0h868.11v162.93H0z"
  }), /*#__PURE__*/React.createElement("g", {
    strokeWidth: "1pt",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M477.305 340.035h47.543v3.271h-47.543zm7.089 16.358h3.271v3.177h-3.271zm40.577-.103v3.271h-9.5v-3.271zm5.111-16.255h3.272v19.532h-3.272z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M549.008 356.29v3.271h-18.006v-3.271zm-33.538-7.642h3.272v10.92h-3.272z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M546.33 340.035h3.272v19.532h-3.272zm-8.18 0h3.273v19.532h-3.272zm-43.404 7.774v3.271h-17.352v-3.271zm38.076 0v3.271H515.47v-3.271z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M515.47 348.648h3.272v10.92h-3.272z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M515.47 348.648h3.272v10.92h-3.272z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M515.47 348.648h3.272v10.92h-3.272zm-38.076 0h3.271v10.92h-3.271zm27.909 0h3.272v10.92h-3.272zm-13.827 0h3.272v10.92h-3.272z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M507.599 356.29v3.271H492.93v-3.271zm.976-8.481v3.271h-9.3v-3.271z"
  })), /*#__PURE__*/React.createElement("g", {
    strokeWidth: "1pt",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M555.535 340.035h47.543v3.271h-47.543zm7.089 16.358h3.271v3.177h-3.271zm40.577-.103v3.271h-9.5v-3.271zm5.111-16.255h3.272v19.532h-3.272z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M627.238 356.29v3.271h-18.006v-3.271zm-33.538-7.642h3.272v10.92H593.7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M624.56 340.035h3.272v19.532h-3.272zm-8.18 0h3.273v19.532h-3.272zm-43.404 7.774v3.271h-17.352v-3.271zm38.076 0v3.271H593.7v-3.271z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M593.7 348.648h3.272v10.92H593.7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M593.7 348.648h3.272v10.92H593.7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M593.7 348.648h3.272v10.92H593.7zm-38.076 0h3.271v10.92h-3.271zm27.909 0h3.272v10.92h-3.272zm-13.827 0h3.272v10.92h-3.272z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M585.829 356.29v3.271H571.16v-3.271zm.976-8.481v3.271h-9.3v-3.271z"
  })), /*#__PURE__*/React.createElement("g", {
    strokeWidth: "1pt",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M633.755 340.035h47.543v3.271h-47.543zm7.089 16.358h3.271v3.177h-3.271zm40.577-.103v3.271h-9.5v-3.271zm5.111-16.255h3.272v19.532h-3.272z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M705.458 356.29v3.271h-18.006v-3.271zm-33.538-7.642h3.272v10.92h-3.272z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M702.78 340.035h3.272v19.532h-3.272zm-8.18 0h3.273v19.532H694.6zm-43.404 7.774v3.271h-17.352v-3.271zm38.076 0v3.271H671.92v-3.271z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M671.92 348.648h3.272v10.92h-3.272z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M671.92 348.648h3.272v10.92h-3.272z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M671.92 348.648h3.272v10.92h-3.272zm-38.076 0h3.271v10.92h-3.271zm27.909 0h3.272v10.92h-3.272zm-13.827 0h3.272v10.92h-3.272z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M664.049 356.29v3.271H649.38v-3.271zm.976-8.481v3.271h-9.3v-3.271z"
  })), /*#__PURE__*/React.createElement("g", {
    strokeWidth: "1pt",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M712.435 340.035h47.543v3.271h-47.543zm7.089 16.358h3.271v3.177h-3.271zm40.577-.103v3.271h-9.5v-3.271zm5.111-16.255h3.272v19.532h-3.272z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M784.138 356.29v3.271h-18.006v-3.271zm-33.538-7.642h3.272v10.92H750.6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M781.46 340.035h3.272v19.532h-3.272zm-8.18 0h3.273v19.532h-3.272zm-43.404 7.774v3.271h-17.352v-3.271zm38.076 0v3.271H750.6v-3.271z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M750.6 348.648h3.272v10.92H750.6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M750.6 348.648h3.272v10.92H750.6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M750.6 348.648h3.272v10.92H750.6zm-38.076 0h3.271v10.92h-3.271zm27.909 0h3.272v10.92h-3.272zm-13.827 0h3.272v10.92h-3.272z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M742.729 356.29v3.271H728.06v-3.271zm.976-8.481v3.271h-9.3v-3.271z"
  })), /*#__PURE__*/React.createElement("g", {
    strokeWidth: "1pt",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.92 340.035h47.542v3.271H7.919zm7.088 16.358h3.271v3.177h-3.271zm40.577-.103v3.271h-9.5v-3.271zm5.111-16.255h3.272v19.532h-3.272z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.622 356.29v3.271H61.616v-3.271zm-33.538-7.642h3.272v10.92h-3.272z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.944 340.035h3.272v19.532h-3.272zm-8.179 0h3.272v19.532h-3.272zm-43.405 7.774v3.271H8.008v-3.271zm38.076 0v3.271H46.084v-3.271z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.084 348.648h3.272v10.92h-3.272z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.084 348.648h3.272v10.92h-3.272z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.084 348.648h3.272v10.92h-3.272zm-38.076 0h3.271v10.92H8.008zm27.909 0h3.272v10.92h-3.272zm-13.827 0h3.272v10.92H22.09z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.213 356.29v3.271H23.545v-3.271zm.976-8.481v3.271h-9.3v-3.271z"
  })), /*#__PURE__*/React.createElement("g", {
    strokeWidth: "1pt",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M165.025 138.975h47.543v3.271h-47.543zm7.089 16.358h3.271v3.177h-3.271zm40.577-.103v3.271h-9.5v-3.271zm5.111-16.255h3.272v19.532h-3.272z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.728 155.23v3.271h-18.006v-3.271zm-33.538-7.642h3.272v10.92h-3.272z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.05 138.975h3.272v19.532h-3.272zm-8.18 0h3.273v19.532h-3.272zm-43.404 7.774v3.271h-17.352v-3.271zm38.076 0v3.271H203.19v-3.271z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.19 147.588h3.272v10.92h-3.272z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.19 147.588h3.272v10.92h-3.272z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.19 147.588h3.272v10.92h-3.272zm-38.076 0h3.271v10.92h-3.271zm27.909 0h3.272v10.92h-3.272zm-13.827 0h3.272v10.92h-3.272z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.319 155.23v3.271H180.65v-3.271zm.976-8.481v3.271h-9.3v-3.271z"
  })), /*#__PURE__*/React.createElement("g", {
    strokeWidth: "1pt",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M86.94 138.975h47.543v3.271H86.94zm7.089 16.358H97.3v3.177h-3.27zm40.577-.103v3.271h-9.5v-3.271zm5.111-16.255h3.272v19.532h-3.272z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.643 155.23v3.271h-18.006v-3.271zm-33.538-7.642h3.272v10.92h-3.272z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.965 138.975h3.272v19.532h-3.272zm-8.179 0h3.272v19.532h-3.272zm-43.405 7.774v3.271H87.03v-3.271zm38.076 0v3.271h-17.352v-3.271z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.105 147.588h3.272v10.92h-3.272z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.105 147.588h3.272v10.92h-3.272z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.105 147.588h3.272v10.92h-3.272zm-38.076 0H90.3v10.92h-3.27zm27.909 0h3.272v10.92h-3.272zm-13.828 0h3.273v10.92h-3.272z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.234 155.23v3.271h-14.668v-3.271zm.976-8.481v3.271h-9.3v-3.271z"
  })), /*#__PURE__*/React.createElement("g", {
    strokeWidth: "1pt",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M242.465 138.975h47.543v3.271h-47.543zm7.089 16.358h3.271v3.177h-3.271zm40.577-.103v3.271h-9.5v-3.271zm5.111-16.255h3.272v19.532h-3.272z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314.168 155.23v3.271h-18.006v-3.271zm-33.538-7.642h3.272v10.92h-3.272z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M311.49 138.975h3.272v19.532h-3.272zm-8.18 0h3.273v19.532h-3.272zm-43.404 7.774v3.271h-17.352v-3.271zm38.076 0v3.271H280.63v-3.271z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.63 147.588h3.272v10.92h-3.272z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.63 147.588h3.272v10.92h-3.272z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.63 147.588h3.272v10.92h-3.272zm-38.076 0h3.271v10.92h-3.271zm27.909 0h3.272v10.92h-3.272zm-13.827 0h3.272v10.92h-3.272z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272.759 155.23v3.271H258.09v-3.271zm.976-8.481v3.271h-9.3v-3.271z"
  })), /*#__PURE__*/React.createElement("g", {
    strokeWidth: "1pt",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M789.275 138.975h47.543v3.271h-47.543zm7.089 16.358h3.271v3.177h-3.271zm40.577-.103v3.271h-9.5v-3.271zm5.111-16.255h3.272v19.532h-3.272z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M860.978 155.23v3.271h-18.006v-3.271zm-33.538-7.642h3.272v10.92h-3.272z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M858.3 138.975h3.272v19.532H858.3zm-8.18 0h3.273v19.532h-3.272zm-43.404 7.774v3.271h-17.352v-3.271zm38.076 0v3.271H827.44v-3.271z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M827.44 147.588h3.272v10.92h-3.272z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M827.44 147.588h3.272v10.92h-3.272z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M827.44 147.588h3.272v10.92h-3.272zm-38.076 0h3.271v10.92h-3.271zm27.909 0h3.272v10.92h-3.272zm-13.827 0h3.272v10.92h-3.272z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M819.569 155.23v3.271H804.9v-3.271zm.976-8.481v3.271h-9.3v-3.271z"
  })), /*#__PURE__*/React.createElement("g", {
    strokeWidth: "1pt",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M320.405 138.975h47.543v3.271h-47.543zm7.089 16.358h3.271v3.177h-3.271zm40.577-.103v3.271h-9.5v-3.271zm5.111-16.255h3.272v19.532h-3.272z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M392.108 155.23v3.271h-18.006v-3.271zm-33.538-7.642h3.272v10.92h-3.272z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M389.43 138.975h3.272v19.532h-3.272zm-8.18 0h3.273v19.532h-3.272zm-43.404 7.774v3.271h-17.352v-3.271zm38.076 0v3.271H358.57v-3.271z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M358.57 147.588h3.272v10.92h-3.272z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M358.57 147.588h3.272v10.92h-3.272z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M358.57 147.588h3.272v10.92h-3.272zm-38.076 0h3.271v10.92h-3.271zm27.909 0h3.272v10.92h-3.272zm-13.827 0h3.272v10.92h-3.272z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M350.699 155.23v3.271H336.03v-3.271zm.976-8.481v3.271h-9.3v-3.271z"
  })), /*#__PURE__*/React.createElement("g", {
    strokeWidth: "1pt",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M398.625 138.975h47.543v3.271h-47.543zm7.089 16.358h3.271v3.177h-3.271zm40.577-.103v3.271h-9.5v-3.271zm5.111-16.255h3.272v19.532h-3.272z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M470.328 155.23v3.271h-18.006v-3.271zm-33.538-7.642h3.272v10.92h-3.272z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M467.65 138.975h3.272v19.532h-3.272zm-8.18 0h3.273v19.532h-3.272zm-43.404 7.774v3.271h-17.352v-3.271zm38.076 0v3.271H436.79v-3.271z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M436.79 147.588h3.272v10.92h-3.272z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M436.79 147.588h3.272v10.92h-3.272z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M436.79 147.588h3.272v10.92h-3.272zm-38.076 0h3.271v10.92h-3.271zm27.909 0h3.272v10.92h-3.272zm-13.827 0h3.272v10.92h-3.272z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M428.919 155.23v3.271H414.25v-3.271zm.976-8.481v3.271h-9.3v-3.271z"
  })), /*#__PURE__*/React.createElement("g", {
    strokeWidth: "1pt",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M477.305 138.975h47.543v3.271h-47.543zm7.089 16.358h3.271v3.177h-3.271zm40.577-.103v3.271h-9.5v-3.271zm5.111-16.255h3.272v19.532h-3.272z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M549.008 155.23v3.271h-18.006v-3.271zm-33.538-7.642h3.272v10.92h-3.272z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M546.33 138.975h3.272v19.532h-3.272zm-8.18 0h3.273v19.532h-3.272zm-43.404 7.774v3.271h-17.352v-3.271zm38.076 0v3.271H515.47v-3.271z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M515.47 147.588h3.272v10.92h-3.272z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M515.47 147.588h3.272v10.92h-3.272z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M515.47 147.588h3.272v10.92h-3.272zm-38.076 0h3.271v10.92h-3.271zm27.909 0h3.272v10.92h-3.272zm-13.827 0h3.272v10.92h-3.272z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M507.599 155.23v3.271H492.93v-3.271zm.976-8.481v3.271h-9.3v-3.271z"
  })), /*#__PURE__*/React.createElement("g", {
    strokeWidth: "1pt",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M555.535 138.975h47.543v3.271h-47.543zm7.089 16.358h3.271v3.177h-3.271zm40.577-.103v3.271h-9.5v-3.271zm5.111-16.255h3.272v19.532h-3.272z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M627.238 155.23v3.271h-18.006v-3.271zm-33.538-7.642h3.272v10.92H593.7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M624.56 138.975h3.272v19.532h-3.272zm-8.18 0h3.273v19.532h-3.272zm-43.404 7.774v3.271h-17.352v-3.271zm38.076 0v3.271H593.7v-3.271z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M593.7 147.588h3.272v10.92H593.7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M593.7 147.588h3.272v10.92H593.7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M593.7 147.588h3.272v10.92H593.7zm-38.076 0h3.271v10.92h-3.271zm27.909 0h3.272v10.92h-3.272zm-13.827 0h3.272v10.92h-3.272z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M585.829 155.23v3.271H571.16v-3.271zm.976-8.481v3.271h-9.3v-3.271z"
  })), /*#__PURE__*/React.createElement("g", {
    strokeWidth: "1pt",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M633.755 138.975h47.543v3.271h-47.543zm7.089 16.358h3.271v3.177h-3.271zm40.577-.103v3.271h-9.5v-3.271zm5.111-16.255h3.272v19.532h-3.272z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M705.458 155.23v3.271h-18.006v-3.271zm-33.538-7.642h3.272v10.92h-3.272z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M702.78 138.975h3.272v19.532h-3.272zm-8.18 0h3.273v19.532H694.6zm-43.404 7.774v3.271h-17.352v-3.271zm38.076 0v3.271H671.92v-3.271z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M671.92 147.588h3.272v10.92h-3.272z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M671.92 147.588h3.272v10.92h-3.272z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M671.92 147.588h3.272v10.92h-3.272zm-38.076 0h3.271v10.92h-3.271zm27.909 0h3.272v10.92h-3.272zm-13.827 0h3.272v10.92h-3.272z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M664.049 155.23v3.271H649.38v-3.271zm.976-8.481v3.271h-9.3v-3.271z"
  })), /*#__PURE__*/React.createElement("g", {
    strokeWidth: "1pt",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M712.435 138.975h47.543v3.271h-47.543zm7.089 16.358h3.271v3.177h-3.271zm40.577-.103v3.271h-9.5v-3.271zm5.111-16.255h3.272v19.532h-3.272z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M784.138 155.23v3.271h-18.006v-3.271zm-33.538-7.642h3.272v10.92H750.6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M781.46 138.975h3.272v19.532h-3.272zm-8.18 0h3.273v19.532h-3.272zm-43.404 7.774v3.271h-17.352v-3.271zm38.076 0v3.271H750.6v-3.271z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M750.6 147.588h3.272v10.92H750.6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M750.6 147.588h3.272v10.92H750.6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M750.6 147.588h3.272v10.92H750.6zm-38.076 0h3.271v10.92h-3.271zm27.909 0h3.272v10.92h-3.272zm-13.827 0h3.272v10.92h-3.272z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M742.729 155.23v3.271H728.06v-3.271zm.976-8.481v3.271h-9.3v-3.271z"
  })), /*#__PURE__*/React.createElement("g", {
    strokeWidth: "1pt",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.92 138.975h47.542v3.271H7.919zm7.088 16.358h3.271v3.177h-3.271zm40.577-.103v3.271h-9.5v-3.271zm5.111-16.255h3.272v19.532h-3.272z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.622 155.23v3.271H61.616v-3.271zm-33.538-7.642h3.272v10.92h-3.272z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.944 138.975h3.272v19.532h-3.272zm-8.179 0h3.272v19.532h-3.272zm-43.405 7.774v3.271H8.008v-3.271zm38.076 0v3.271H46.084v-3.271z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.084 147.588h3.272v10.92h-3.272z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.084 147.588h3.272v10.92h-3.272z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.084 147.588h3.272v10.92h-3.272zm-38.076 0h3.271v10.92H8.008zm27.909 0h3.272v10.92h-3.272zm-13.827 0h3.272v10.92H22.09z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.213 155.23v3.271H23.545v-3.271zm.976-8.481v3.271h-9.3v-3.271z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M119.3 328.94h5.86v10.178h-5.86zm155.54 0h5.86v10.178h-5.86zm-274.882 0h5.86v10.178h-5.86zm78.941 0h5.86v10.178h-5.86zm78.379 0h5.86v10.178h-5.86zm38.78 0h5.86v10.178h-5.86zm39.59 0h5.86v10.178h-5.86zm77.972 0h5.86v10.178h-5.86zm196.74 0h5.86v10.178h-5.86zm-157.152 0h5.86v10.178h-5.86zm38.79 0h5.86v10.178h-5.86zm39.18 0h5.86v10.178h-5.86zm39.19 0h5.86v10.178h-5.86zm313.092 0h5.86v10.178h-5.86zm-235.122 0h5.86v10.178h-5.86zm39.59 0h5.86v10.178h-5.86zm40 0h5.86v10.178h-5.86zm37.57 0h5.86v10.178h-5.86zm39.99 0h5.86v10.178h-5.86zm39.19 0h5.86v10.178h-5.86zm115.952 0h5.86v10.178h-5.86zm-37.572 0h5.86v10.178h-5.86zm-783.75 0h5.86v10.178h-5.86z",
    strokeWidth: "1pt",
    fill: "#d90000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.3 157.55h5.86v10.178h-5.86zm155.54 0h5.86v10.178h-5.86zm-274.882 0h5.86v10.178h-5.86zm78.941 0h5.86v10.178h-5.86zm78.379 0h5.86v10.178h-5.86zm38.78 0h5.86v10.178h-5.86zm39.59 0h5.86v10.178h-5.86zm77.972 0h5.86v10.178h-5.86zm196.74 0h5.86v10.178h-5.86zm-157.152 0h5.86v10.178h-5.86zm38.79 0h5.86v10.178h-5.86zm39.18 0h5.86v10.178h-5.86zm39.19 0h5.86v10.178h-5.86zm313.092 0h5.86v10.178h-5.86zm-235.122 0h5.86v10.178h-5.86zm39.59 0h5.86v10.178h-5.86zm40 0h5.86v10.178h-5.86zm37.57 0h5.86v10.178h-5.86zm39.99 0h5.86v10.178h-5.86zm39.19 0h5.86v10.178h-5.86zm115.952 0h5.86v10.178h-5.86zm-37.572 0h5.86v10.178h-5.86zm-783.75 0h5.86v10.178h-5.86z",
    strokeWidth: "1pt",
    fill: "#239e3f"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#da0000"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M457.079 191.36c8.19 10.039 33.438 65.548-15.241 101.91-22.884 17.223-8.714 18.093-8.037 20.988 36.785-19.539 48.799-46.013 48.52-69.727-.28-23.715-12.853-44.669-25.242-53.167z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M461.949 188.78c18.166 9.301 57.701 56.079 15.149 108.85 26.439-5.868 60.053-83.729-15.149-108.85zm-55.79 0c-18.166 9.301-57.701 56.079-15.149 108.85-26.439-5.868-60.053-83.729 15.149-108.85z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M410.959 191.36c-8.19 10.039-33.438 65.548 15.241 101.91 22.884 17.223 8.714 18.093 8.037 20.988-36.785-19.539-48.799-46.013-48.52-69.727.28-23.715 12.853-44.669 25.242-53.167z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M480.719 309.2c-14.398.228-32.549-1.984-46.01-8.979 2.217 4.311 4.059 7.026 6.276 11.337 12.838 1.184 30.554 2.649 39.734-2.358zm-92.02 0c14.398.228 32.549-1.984 46.01-8.979-2.217 4.311-4.059 7.026-6.276 11.337-12.838 1.184-30.554 2.649-39.734-2.358zm26.41-134.4c2.917 7.753 10.57 8.88 18.762 4.315 5.97 3.582 15.202 3.809 18.386-3.94 2.421 19.169-17.736 14.634-18.487 10.882-7.504 7.254-21.475 3.064-18.661-11.257z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M434.409 321.27l7.57-8.652 1.082-116.44-9.012-7.931-9.012 7.57 1.802 117.16 7.57 8.291z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIr);
export default __webpack_public_path__ + "static/media/ir.63ab499d8d6dc2ae925ad7f6592e8388.svg";
export { ForwardRef as ReactComponent };